import styles from "./FeatureInfo.module.css";

// React
import React from "react";
import { NavLink } from "react-router-dom";

// Tools
import GetModule from "tools/getModule";

// components
import FeatureTitleAndDevDays from "components/FeatureTitleAndDevDays";
import StatusTitle from "components/StatusTitle";

// context
import { useContext } from "react";
import { MyContext } from "components/RoleContext";
import { Role } from "tools/Enums";

export default function FeatureInfo(props) {
	const { role } = useContext(MyContext);
	return (
		<NavLink to={{ pathname: `/comments/${props.feature.idFeature}` }} className={styles.container}>
			<div className={styles.header}>
				<FeatureTitleAndDevDays feature={props.feature} />
				{role == Role.User && <StatusTitle status={props.feature.status} />}
			</div>
			<div className={styles.description} title={props.feature.description}>
				{props.feature.description}
			</div>
			<div className={styles.dateAndModule}>
				{new Date(props.feature.created).toDateString() + " in "}
				<span className={styles.module}>{GetModule.getName(props.feature.module)}</span> module{" "}
				{role === Role.Admin && (
					<>
						{props.feature.requestedBy.length !== 0 ? <b className={styles.module}>Requested By: </b> : ""}
						{props.feature.requestedBy.map((user) => {
							return <span key={user.id}>{user.userName} </span>;
						})}
					</>
				)}
			</div>
		</NavLink>
	);
}
